import { Grid, Stack, Typography } from "@mui/material";

import PossibilitiesItem from "../CarouselItem/PossibilitiesItem";

import { LayoutContainer } from "../../app-layoout/container";

import { formatMoney } from "../../../lib/formatMoney";
import { SearchPropeties } from "../../SearchPropeties";
import { useUserData } from "../../../hooks/use-data-user";

const Possibilities = ({ dataListPropertiesQuery }) => {
  const { userDataQuery } = useUserData();

  return (
    <Stack py={5}>
      <Stack pb={5} pt={{xs: 0, md: 5}}>
        <SearchPropeties dataListPropertiesQuery={dataListPropertiesQuery} />
      </Stack>
      <LayoutContainer>
        <Grid container spacing={{ xs: 2, md: 1.2, xl: 2 }}>
          {!!dataListPropertiesQuery.data ? (
            dataListPropertiesQuery.data.data.length === 0 ? (
              <Stack
                width={"100%"}
                height={"300px"}
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h5" color="text.secondary" mb={2}>
                  No se encontraron propiedades
                </Typography>
              </Stack>
            ) : (
              dataListPropertiesQuery.data.data
                .map((items) => {
                  let saleStage = [];
                  if (!!items.IDO) {
                    saleStage = items.IDO.iDOSaleStage;
                  }

                  if (!!items.Token) {
                    saleStage = items.Token.tokenSaleStage;
                  }

                  return {
                    id: items.id || "",
                    slug: items?.slug || "",
                    img: items.cardImageUrl || "/assets/about/plusvalica.png",
                    name: items.name || "",
                    description: items?.description?.descripcion || "",
                    isNormal: items.isNormal,
                    isTokenize: items.isTokenize,
                    isIDO: items.isIDO,
                    isSoo: items.isSoo,
                    city: items.city || "",
                    price: `${formatMoney({
                      amount: Number(items?.price || "0"),
                      symbol: "$ ",
                      append: false,
                    })}  USD`,
                    priceMxn: items?.priceMxn
                      ? formatMoney({
                          amount: Number(items.priceMxn),
                          symbol: "$ ",
                          append: false,
                          decimals: 2,
                        }) + " MXN"
                      : "",
                    priceSoil: `${formatMoney({
                      amount: Number(items?.price || "0"),
                      symbol: " ",
                      append: false,
                    })}  Soil`,
                    saleStage,
                    sponsor: userDataQuery.data?.username || "",
                  };
                })
                .map((item, i) => (
                  <Grid item xs={12} sm={6} md={2.35} xl={2.35} key={i}>
                    <PossibilitiesItem {...item} />
                  </Grid>
                ))
            )
          ) : (
            <></>
          )}
        </Grid>
      </LayoutContainer>
    </Stack>
  );
};

export default Possibilities;
